var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2344 1.125C16.532 1.125 16.8175 1.24353 17.028 1.4545C17.2385 1.66548 17.3568 1.95163 17.3568 2.25V15.75C17.3568 16.0484 17.2385 16.3345 17.028 16.5455C16.8175 16.7565 16.532 16.875 16.2344 16.875H2.76566C2.46798 16.875 2.1825 16.7565 1.97201 16.5455C1.76152 16.3345 1.64327 16.0484 1.64327 15.75V2.25C1.64327 1.95163 1.76152 1.66548 1.97201 1.4545C2.1825 1.24353 2.46798 1.125 2.76566 1.125H16.2344ZM2.76566 0C2.1703 0 1.59933 0.237053 1.17836 0.65901C0.757377 1.08097 0.520874 1.65326 0.520874 2.25L0.520874 15.75C0.520874 16.3467 0.757377 16.919 1.17836 17.341C1.59933 17.7629 2.1703 18 2.76566 18H16.2344C16.8297 18 17.4007 17.7629 17.8217 17.341C18.2426 16.919 18.4791 16.3467 18.4791 15.75V2.25C18.4791 1.65326 18.2426 1.08097 17.8217 0.65901C17.4007 0.237053 16.8297 0 16.2344 0L2.76566 0Z",
    fill: "#003566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50007 4.5C9.6489 4.5 9.79165 4.55926 9.89689 4.66475C10.0021 4.77024 10.0613 4.91332 10.0613 5.0625V8.4375H13.4284C13.5773 8.4375 13.72 8.49676 13.8253 8.60225C13.9305 8.70774 13.9896 8.85082 13.9896 9C13.9896 9.14918 13.9305 9.29226 13.8253 9.39775C13.72 9.50324 13.5773 9.5625 13.4284 9.5625H10.0613V12.9375C10.0613 13.0867 10.0021 13.2298 9.89689 13.3352C9.79165 13.4407 9.6489 13.5 9.50007 13.5C9.35123 13.5 9.20848 13.4407 9.10324 13.3352C8.998 13.2298 8.93887 13.0867 8.93887 12.9375V9.5625H5.57169C5.42286 9.5625 5.28011 9.50324 5.17487 9.39775C5.06962 9.29226 5.0105 9.14918 5.0105 9C5.0105 8.85082 5.06962 8.70774 5.17487 8.60225C5.28011 8.49676 5.42286 8.4375 5.57169 8.4375H8.93887V5.0625C8.93887 4.91332 8.998 4.77024 9.10324 4.66475C9.20848 4.55926 9.35123 4.5 9.50007 4.5Z",
    fill: "#003566"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9583,
    height: 18,
    fill: "white",
    transform: "translate(0.520874)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.e67ac61dd278a1c6b2a50a6be4a394fe.svg";
export { ForwardRef as ReactComponent };